/** @format */

import { ProductPrice } from '@shared/data-access/interfaces';

export const oosPrice: ProductPrice = {
	emptyPrice: false,
	maxListPrice: '',
	maxOfferPrice: '',
	maxSavingPct: '',
	minListPrice: '',
	minOfferPrice: 0.0,
	minSavingPct: ''
};
